Vue.component("category-attribute-images", {
  props: {
    attrimagesData: { type: Object, required: true },
    itemurl: { type: String, default: '' },
    variationHoverImages: { type: String, default: '' },
    activeVariationId: { type: [Number, String], default: null }
  },
  data() {
    return {
      // Speichert die aktuell fokussierte Variation
      currentActiveId: null,
      // Blockiert den nächsten Click, wenn der erste Touch nur das Bild wechseln sollte
      touchClickBlocked: false
    };
  },
  computed: {
    hoverImageMap() {
      const map = {};
      if (!this.variationHoverImages || typeof this.variationHoverImages !== 'string') return map;
      const entries = this.variationHoverImages.split(';');
      entries.forEach(entry => {
        const match = entry.match(/\[(.*?)\]:(.*)/);
        if (match) {
          const ids = match[1].split(','); 
          const url = match[2].trim();
          ids.forEach(id => { map[id.trim()] = url; });
        }
      });
      return map;
    },
    colorAttributes() {
      const data = this.attrimagesData;
      if (!data || !data.attributes) return [];

      const colorAttr = data.attributes.find(a => a.attributeId === 1);
      if (!colorAttr || !colorAttr.values) return [];

      const urlBase = this.itemurl.split('_').slice(0, -1).join('_');

      return colorAttr.values.map(val => {
        const variationsWithThisColor = data.variations.filter(v =>
          v.attributes && v.attributes.some(a => a.attributeId === 1 && a.attributeValueId === val.attributeValueId)
        );

        if (variationsWithThisColor.length === 0) return null;

        const isActiveColor = variationsWithThisColor.some(v => v.variationId == this.activeVariationId);

        const targetVariationId = isActiveColor 
          ? this.activeVariationId 
          : variationsWithThisColor[0].variationId;

        return {
          name: val.name,
          imageUrl: val.imageUrl ? val.imageUrl.replace(/\\/g, '') : '',
          variationId: targetVariationId,
          vUrl: urlBase + '_' + targetVariationId,
          hoverImageUrl: this.hoverImageMap[targetVariationId] || null,
          attributeValueId: val.attributeValueId
        };
      }).filter(item => item !== null);
    }
  },
  mounted() {
    // Initialisierung: Falls eine Variation aktiv ist, setzen wir sie als aktuellen State.
    // Außerdem wird das Hover-Bild initial bereits im DOM vorbereitet.
    if (this.activeVariationId != null) {
      this.currentActiveId = this.activeVariationId;
    } else if (this.colorAttributes.length > 0) {
      this.currentActiveId = this.colorAttributes[0].variationId;
    }

    this.$nextTick(() => {
      const initialColor = this.colorAttributes.find(color => color.variationId == this.currentActiveId);
      if (initialColor) {
        this.handleHover(initialColor);
      }
    });
  },
  watch: {
    activeVariationId(newVal) {
      if (newVal != null) {
        this.currentActiveId = newVal;
      }
    }
  },
  methods: {
    
    handleTouchStart(event, color) {
      if (this.currentActiveId !== color.variationId) {
        event.preventDefault();
        event.stopPropagation();
        this.touchClickBlocked = true;
        this.handleHover(color);
      } else {
        this.touchClickBlocked = false;
      }
    },

    handleLinkClick(event, color) {
      if (this.touchClickBlocked) {
        event.preventDefault();
        event.stopPropagation();
        this.touchClickBlocked = false;
        return;
      }

      const isTouch = event.pointerType === 'touch' || event.type?.startsWith('touch');
      if (isTouch && this.currentActiveId !== color.variationId) {
        event.preventDefault();
        event.stopPropagation();
        this.handleHover(color);
      }
    },

    handleHover(color) {
      const card = this.$el.closest('.category-list-item');
      if (!card || !color) return;

      // WICHTIG: State aktualisieren für den Klick-Vergleich
      this.currentActiveId = color.variationId;

      // 1. Erstes Bild (Vorschau) tauschen
      const mainImg = card.querySelector('.first-image');
      if (mainImg) mainImg.src = color.imageUrl;

      // 2. Zweites Bild (Hover-Effekt) vorbereiten
      const imageContainer = card.querySelector('.category-item-image-link');
      if (imageContainer && color.hoverImageUrl) {
        let secondImg = imageContainer.querySelector('.second-image');
        if (!secondImg) {
          secondImg = document.createElement('img');
          secondImg.width = 265;
          secondImg.height = 265;
          secondImg.loading = 'lazy';
          secondImg.classList.add('second-image');
          imageContainer.appendChild(secondImg);
        }
        secondImg.src = color.hoverImageUrl;
      }

      // 3. Alle Links der Produktkarte auf die neue Variation URL aktualisieren
      const mainLinks = card.querySelectorAll('a');
      mainLinks.forEach(link => {
        // Verhindert, dass wir den href der Farbwähler selbst überschreiben (Endlosschleife-Gefahr)
        if (!link.closest('.attribute-images-selector')) {
          link.href = color.vUrl;
        }
      });
    }
  }
});